/**
 * Helpers de busca tolerante a acentos para inputs PT-BR.
 *
 * `normalizeForSearch` aplica NFD + remove combining diacritics + lowercase + trim.
 * `matchesSearch` compara haystack/needle ja normalizados (substring includes).
 *
 * Convencao: query vazia => match all (true). Inputs null/undefined sao tratados
 * como string vazia (nao quebra filtros que recebem campos opcionais do banco).
 */

/**
 * Normaliza string removendo acentos pra busca tolerante.
 * "Joao" => "joao". Lowercase aplicado. Suporta portugues + extensoes basicas
 * cobertas pelo bloco Unicode Combining Diacritical Marks (U+0300..U+036F).
 */
export function normalizeForSearch(str: string | null | undefined): string {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

/**
 * Match accent-insensitive case-insensitive entre `haystack` e `needle`.
 * Query vazia/whitespace-only => true (nao filtra).
 */
export function matchesSearch(
  haystack: string | null | undefined,
  needle: string | null | undefined,
): boolean {
  const h = normalizeForSearch(haystack);
  const n = normalizeForSearch(needle);
  if (!n) return true;
  return h.includes(n);
}
